import { render, staticRenderFns } from "./TicketsTable.vue?vue&type=template&id=524eada2&"
import script from "./TicketsTable.vue?vue&type=script&lang=ts&"
export * from "./TicketsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsTable.vue?vue&type=style&index=0&id=524eada2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports